export const validateLeftSideBox = (values, locale = "fa") => {
  const errors = {};
  const errorMsg = locale === "fa" ? 'كد تخفيف را وارد كنيد' : "Enter Discount Code";
  if (!values.discountCode) {
    errors.discountCode = errorMsg;
  }
  return errors;
};
